document.addEventListener("DOMContentLoaded", function() {
  // Check if the current URL path includes '/collections' or '/search'
  const currentPath = window.location.pathname;

  if (currentPath.includes('/collections')) {
    // Get the checkbox element by its ID
    const checkbox = document.getElementById('Filter-filter.v.availability-1');

    // Check if the checkbox is not checked
    if (!checkbox.checked) {
      // Click the checkbox to check it
      checkbox.click();
    }
  }
});

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if(facetForm){
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    let filterCloseBtnMob = document.querySelector(".mobile-facets__close");
    if(filterCloseBtnMob){  // closing the filter drawer
      const menuDrawerIndexing = document.querySelector('menu-drawer');
      filterCloseBtnMob.addEventListener("click",function(){
        document.querySelector(".mobile-facets__disclosure").classList.remove('menu-opening');
        document.querySelector(".mobile-facets__disclosure").removeAttribute('open');
        if(menuDrawerIndexing && menuDrawerIndexing.classList.contains('tw-z-50')){
          menuDrawerIndexing.classList.add('tw-z-[1]');
          menuDrawerIndexing.classList.remove('tw-z-50');
        }
        document.body.style.overflow = 'auto';
      })
    }
  }

  connectedCallback(){
    //sort option select color change
    let sortingOptionBtn = document.querySelectorAll(".sort-option-mobile");
    let sortingOptionBtnDesktop = document.querySelectorAll(".sort-option-desktop"); 
    this.sortSelectedValue(sortingOptionBtn,".sort-option-mobile");
    this.sortSelectedValue(sortingOptionBtnDesktop,".sort-option-desktop");
  }

  sortSelectedValue(sortBtn,selector){
    for( let i=0;i<sortBtn.length;i++){
      sortBtn[i].addEventListener("click",function(){ 
        let current = document.querySelectorAll(`${selector}.active`);
        current[0].className = current[0].className.replace(" active", "");
        this.className += " active";
        const menuDrawerIndexing = document.querySelector('menu-drawer');
        if(selector.includes("mobile")){
          document.querySelector(".sorting-popup-mobile").classList.add("tw-hidden");
          document.querySelector(".sort-background").style.display ="none";
          if(menuDrawerIndexing && menuDrawerIndexing.classList.contains('tw-z-50')){
            menuDrawerIndexing.classList.add('tw-z-[1]');
            menuDrawerIndexing.classList.remove('tw-z-50');
          }
        }
      })
    }
  }
  
  static setListeners() {
    const onHistoryChange = (event) => {
      // if condition added by team searchtap
      let url = window.location.href;
      if(url && !url.includes('/searchtap-search')) {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
      }
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    if (countContainer){
      showLoader();
    }
    if (countContainerDesktop){
      showLoader();
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.sortDesktopPopup();
        allHulkWishlistButtons = Array.from(document.querySelectorAll('[data-wishlist]'));
        HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static sortDesktopPopup(){
    //desktop sort close and open
    let sortBtnDesktop = document.querySelector(".sort-desktop");
    sortBtnDesktop?.addEventListener("click",function(){
      if(document.querySelector(".sorting-popup-desktop").classList.contains("tw-hidden")){
        document.querySelector(".sorting-popup-desktop").classList.remove("tw-hidden");
      } else {
        document.querySelector(".sorting-popup-desktop").classList.add("tw-hidden");
      }
    })
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    closeLoader();
    window.scrollTo({ top: 0, behavior: 'smooth' })
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      closeLoader();
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      if (!element.classList.contains('tw-hidden') && document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`)) {
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      }      
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const baseUrl = `${window.location.pathname}`;
    const utmParams = new URLSearchParams(window.location.search);
    const preservedParams = ['utm_source', 'utm_medium', 'utm_campaign'];

    preservedParams.forEach(param => {
      if (utmParams.has(param)) {
        searchParams += `&${param}=${utmParams.get(param)}`;
      }
    });

    history.pushState({ searchParams }, '', `${baseUrl}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        id: 'product-grid',
        section: document.getElementById('product-grid').dataset.id
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();

    //Price 
    this.querySelectorAll("[name='price']").forEach((btn)=>{
      btn.addEventListener("change",function(){
          let minValue = this.getAttribute("data-min-value");
          let maxValue = this.getAttribute("data-max-value");
          let rangeMin = document.querySelector("#Filter-Price-GTE");
          let rangeMax = document.querySelector("#Filter-Price-LTE");
          let mobileRangeMin = document.querySelector("#Mobile-Filter-Price-GTE");
          let mobileRangeMax = document.querySelector("#Mobile-Filter-Price-LTE");
          rangeMin.value = minValue;
          rangeMax.value = maxValue;
          mobileRangeMin.value = minValue;
          mobileRangeMax.value = maxValue;
        })
    })
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);



// Helper function to toggle the visibility of sort popups
function sortPopup(selector, device) {
  const popup = document.querySelector(selector);
  const menuDrawerIndexing = document.querySelector('menu-drawer');
  const isHidden = popup.classList.contains("tw-hidden");

  popup.classList.toggle("tw-hidden", !isHidden);

  if (device === "mobile") {
    document.querySelector(".sort-background").style.display = isHidden ? "block" : "none";
    if (menuDrawerIndexing) {
      menuDrawerIndexing.classList.toggle('tw-z-50', isHidden);
      menuDrawerIndexing.classList.toggle('tw-z-[1]', !isHidden);
    }
  }
}

// Event listeners for mobile and desktop sort buttons
const sortBtn = document.querySelector(".sort-btn-mobile");
sortBtn?.addEventListener("click", () => sortPopup(".sorting-popup-mobile", "mobile"));

const backgroundSortClose = document.querySelector(".sort-background");
backgroundSortClose?.addEventListener("click", () => sortPopup(".sorting-popup-mobile", "mobile"));

const sortBtnDesktop = document.querySelector(".sort-desktop");
sortBtnDesktop?.addEventListener("click", () => sortPopup(".sorting-popup-desktop"));
